/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "gambit": {
            "nested": {
              "api": {
                "nested": {
                  "v1": {
                    "nested": {
                      "checkdeposit": {
                        "nested": {
                          "WorkflowVersion": {
                            "values": {
                              "WORKFLOW_VERSION_UNSPECIFIED": 0,
                              "WORKFLOW_VERSION_GAMBIT_ADMINISTERED": 1,
                              "WORKFLOW_VERSION_V1": 2,
                              "WORKFLOW_VERSION_V2_ENSENTA": 3,
                              "WORKFLOW_VERSION_V2O_ENSENTA": 4
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.gambit?.nested?.api?.nested?.v1?.nested?.checkdeposit?.nested?.WorkflowVersion) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE WorkflowVersion @ squareup/cash/gambit/api/v1/checkdeposit/workflow_version.proto at 7:1
 */
export const WorkflowVersion = $root.lookupEnum('squareup.cash.gambit.api.v1.checkdeposit.WorkflowVersion').values;